import { useQuery } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';
import { Database } from '@/_constants/database.types';

type PastPaper = Database['public']['Tables']['past_papers']['Row'];

const usePastPapers = () => {
  const queryFn = async () => {
    return getPastPapers();
  };

  return useQuery({
    queryKey: ['past_papers'],
    queryFn,
  });
};

export default usePastPapers;

async function getPastPapers(): Promise<PastPaper[]> {
  const { data, error } = await supabaseClient
    .from('past_papers')
    .select('*')
    .in('paper_code', ['1EN0/01', '1EN0/02']) // English Language Paper 1 and Paper 2
    .eq('status', 'published')
    .order('date', { ascending: false });

  if (error) throw new Error(error.message);

  return data ?? [];
}
